"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtmsHidden = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UtmsHidden = props => {
  var {
    updateUTMFields
  } = props;
  var [pageDetails, setPageDetails] = (0, _react.useState)({});
  var pageTitle,
    pageUrl,
    seoTitle = '';
  (0, _react.useEffect)(() => {
    updateUTMFields(pageDetails);
  }, [pageDetails]);
  if (typeof window !== 'undefined') {
    pageTitle = document.title;
    var url = new URL(document.location.href);
    url.search = '';
    pageUrl = url.href;
    seoTitle = pageTitle;
  }
  var refreshCookie = () => {
    var url = new URL(document.location.href);
    url.search = '';
    pageUrl = url.href;
    seoTitle = document.title;
    var utmParams = getCookieJson('UtmParms', true);
    var utmFields = {};
    if (utmParams) {
      utmFields = utmParams;
    }
    utmFields.advertisementId = utmFields.gclid;
    setPageDetails(_objectSpread({
      pageUrl,
      seoTitle
    }, utmFields));
  };
  (0, _react.useEffect)(() => {
    (0, _lodash.delay)(refreshCookie, 5000, props);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
exports.UtmsHidden = UtmsHidden;
var getCookieValue = key => {
  if (typeof Element === 'undefined') {
    return;
  }
  var re = new RegExp(key + '=([^]+)');
  var value = re.exec(document.cookie);
  return value !== null ? unescape(value[1]) : null;
};
var getCookieJson = function getCookieJson(cookieValues) {
  var useCamelCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var cookieValue = getCookieValue(cookieValues);
  if ((0, _lodash.isNull)(cookieValue)) {
    return null;
  }
  var utmsArray = (0, _lodash.split)(cookieValue, '&');
  return (0, _lodash.reduce)(utmsArray, (result, value) => {
    var utmSplit = value.split('=');
    useCamelCase ? result[(0, _lodash.camelCase)(utmSplit[0])] = utmSplit[1] : result[utmSplit[0]] = utmSplit[1];
    return result;
  }, {});
};